import { NgModule } from '@angular/core';
import {
  MatButtonModule,
  MatTableModule,
  MatIconModule,
  MatSortModule,
  MatPaginatorModule,
  MatFormFieldModule,
  MatInputModule,
  MatDialogModule,
  MatToolbarModule,
  MatGridListModule,
  MatRadioModule,
  MatCheckboxModule,
  MatSnackBarModule,
  MatCardModule,
  MatExpansionModule,
  MatSidenavModule,
  MatListModule,
  MatDividerModule,
  MatNativeDateModule,
  MatTooltipModule,
  MatStepperModule,
  MatSelectModule,
  MatChipsModule,
  MatBadgeModule,
  MatMenuModule,
  MatDatepickerModule,
  MatTabsModule
} from '@angular/material';

//import {TextFieldModule} from '@angular/cdk/text-field';
const material = [

  MatButtonModule,
  MatIconModule,
  MatTableModule,
  MatSortModule,
  MatPaginatorModule,
  MatFormFieldModule,
  MatInputModule,
  MatDialogModule,
  MatToolbarModule,
  MatGridListModule,
  MatRadioModule,
  MatCheckboxModule,
  MatSnackBarModule,
  MatCardModule,
  MatExpansionModule,
  MatSidenavModule,
  MatListModule,
  MatDividerModule,
  MatNativeDateModule,
  MatTooltipModule,
  //TextFieldModule,
  MatStepperModule,
  MatSelectModule,
  MatChipsModule,
  MatBadgeModule,
  MatMenuModule,
  MatDatepickerModule,
  MatTabsModule
]

@NgModule({
  imports: [material],
  exports : [material]
})
export class MaterialModule { }
